module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "bar-chart"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.iterations.campaign-statistics')))]), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-12"
  }, [_c('div', {
    staticClass: "campaign-statistics-title"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.iterations.overall')))]), _c('div', {
    staticClass: "campaign-statistics-date"
  }, [_vm._v(_vm._s(_vm.totalIterations.startDate) + " - " + _vm._s(_vm.totalIterations.endDate))])]), _c('div', {
    staticClass: "col-md-10 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.stats(_vm.totalIterations, true)), function(stat, index) {
    return _c('div', {
      staticClass: "col-sm-6 mb-3",
      class: stat.details ? 'col-md-6' : _vm.itemClass
    }, [_c('stat-box', {
      attrs: {
        "title": stat.title,
        "value": _vm.statValue(stat.icon, stat.value),
        "icon": stat.icon,
        "details": stat.details
      }
    })], 1)
  }))])]), _c('div', {
    staticClass: "campaign-statistics-break-line"
  }), (_vm.currentIteration) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "campaign-statistics-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.iterations.single-flight-stats')))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-12"
  }, [_c('div', {
    staticClass: "campaign-statistics-title"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.iterations.current'))), _c('div', {
    staticClass: "campaign-statistics-date"
  }, [_vm._v(_vm._s(_vm.currentIteration.startDate) + " - " + _vm._s(_vm.currentIteration.endDate))])])]), _c('div', {
    staticClass: "col-md-10 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.stats(_vm.currentIteration, false)), function(stat, index) {
    return _c('div', {
      staticClass: "col-sm-6 mb-3",
      class: stat.details ? 'col-md-6' : _vm.itemClass
    }, [_c('stat-box', {
      attrs: {
        "title": stat.title,
        "value": _vm.statValue(stat.icon, stat.value),
        "icon": stat.icon,
        "details": stat.details
      }
    })], 1)
  }))])])] : _vm._e(), _vm._l((_vm.selectedIterations), function(iteration) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2 col-sm-12"
    }, [_c('div', {
      staticClass: "campaign-statistics-column",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "campaign-statistics-remove-iteration",
      on: {
        "click": _vm.onRemoveSelectedIteration
      }
    }, [_c('icon', {
      attrs: {
        "name": "remove",
        "scale": "0.9"
      }
    })], 1), _c('div', {
      staticClass: "campaign-statistics-title"
    }, [_vm._v(_vm._s(iteration.shortMonthName) + " " + _vm._s(iteration.year))]), _c('div', {
      staticClass: "campaign-statistics-date"
    }, [_vm._v(_vm._s(iteration.startDate) + " - " + _vm._s(iteration.endDate))])])]), _c('div', {
      staticClass: "col-md-10 col-sm-12"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((_vm.stats(iteration, false)), function(stat, index) {
      return _c('div', {
        staticClass: "col-sm-6 mb-3",
        class: stat.details ? 'col-md-6' : _vm.itemClass
      }, [_c('stat-box', {
        attrs: {
          "title": stat.title,
          "value": _vm.statValue(stat.icon, stat.value),
          "icon": stat.icon,
          "details": stat.details
        }
      })], 1)
    }))])])
  }), (!_vm.isShownCalendar && !_vm.isOneOff) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "campaign-statistics-add-flight",
    on: {
      "click": _vm.onToggleCalendar
    }
  }, [_c('span', {
    staticClass: "campaign-statistics-add-flight-label"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.iterations.add-flight')))]), _c('br'), _c('span', {
    staticClass: "campaign-statistics-add-flight-icon"
  }, [_c('icon', {
    attrs: {
      "name": "angle-down",
      "scale": "1.4"
    }
  })], 1)])]) : _vm._e(), (_vm.isShownCalendar && !_vm.isOneOff) ? [_c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "campaign-statistics-add-flight",
    on: {
      "click": _vm.onToggleCalendar
    }
  }, [_c('span', {
    staticClass: "campaign-statistics-add-flight-label"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.iterations.add-flight')))]), _c('br'), _c('span', {
    staticClass: "campaign-statistics-add-flight-icon"
  }, [_c('icon', {
    attrs: {
      "name": "angle-up",
      "scale": "1.4"
    }
  })], 1)]), _c('div', {
    staticClass: "row campaign-statistics-calendar"
  }, [_c('div', {
    staticClass: "col-xs-2 campaign-statistics-year-box"
  }, [(_vm.hasIteration(_vm.prevYear)) ? _c('div', {
    staticClass: "campaign-statistics-year",
    staticStyle: {
      "left": "0"
    },
    on: {
      "click": function($event) {
        _vm.onChangeYear(_vm.prevYear)
      }
    }
  }, [_c('icon', {
    staticClass: "campaign-statistics-year-arrow",
    attrs: {
      "name": "angle-left",
      "scale": "2.5"
    }
  }), _c('span', {
    staticClass: "campaign-statistics-year-prev"
  }, [_vm._v(_vm._s(_vm.prevYear))])], 1) : _vm._e()]), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row campaign-statistics-calendar"
  }, _vm._l((_vm.calendarMonths), function(month, monthNumber) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2 mt-2 p-0"
    }, [_c('div', {
      staticClass: "campaign-statistics-month"
    }, [_c('gotu-nav-button', {
      staticStyle: {
        "padding": "0",
        "width": "98px"
      },
      attrs: {
        "theme": month.hasIteration ? "default-filter" : "default",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onMonthClicked(_vm.selectedYear, monthNumber)
        }
      }
    }, [_vm._v(_vm._s(month.monthName) + " '" + _vm._s(month.year))])], 1)])
  }))]), _c('div', {
    staticClass: "col-xs-2 campaign-statistics-year-box"
  }, [(_vm.hasIteration(_vm.nextYear)) ? _c('div', {
    staticClass: "campaign-statistics-year",
    staticStyle: {
      "right": "0"
    },
    on: {
      "click": function($event) {
        _vm.onChangeYear(_vm.nextYear)
      }
    }
  }, [_c('span', {
    staticClass: "campaign-statistics-year-next"
  }, [_vm._v(_vm._s(_vm.nextYear))]), _c('icon', {
    staticClass: "campaign-statistics-year-arrow",
    attrs: {
      "name": "angle-right",
      "scale": "2.5"
    }
  })], 1) : _vm._e()])])])] : _vm._e()], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48b12390"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-statistics/CampaignStatistics.vue
// module id = 2038
// module chunks = 1